import { render, staticRenderFns } from "./ChatDialogSequence.vue?vue&type=template&id=5204009e&scoped=true&"
import script from "./ChatDialogSequence.vue?vue&type=script&lang=js&"
export * from "./ChatDialogSequence.vue?vue&type=script&lang=js&"
import style0 from "./ChatDialogSequence.vue?vue&type=style&index=0&id=5204009e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5204009e",
  null
  
)

export default component.exports